export default "__VITE_ASSET__DUk4kYya__"